import { Icon } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';

type LegacyCartIconProps = ComponentProps<typeof Icon>;

export const LegacyCartIcon = (props: LegacyCartIconProps) => {
  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M3.7072 15.6H12.2128C13.7056 15.6 14.92 14.3856 14.92 12.8928V4.8C14.92 4.536 14.704 4.32 14.44 4.32H11.56V3.6C11.56 1.6152 9.9448 0 7.96 0C5.9752 0 4.36 1.6152 4.36 3.6V4.32H1.48C1.216 4.32 1 4.536 1 4.8V12.8928C1 14.3856 2.2144 15.6 3.7072 15.6ZM5.32 3.6C5.32 2.1432 6.5032 0.96 7.96 0.96C9.4168 0.96 10.6 2.1432 10.6 3.6V4.32H5.32V3.6ZM1.96 5.28H4.36V6.48C4.36 6.744 4.576 6.96 4.84 6.96C5.104 6.96 5.32 6.744 5.32 6.48V5.28H10.6V6.48C10.6 6.744 10.816 6.96 11.08 6.96C11.344 6.96 11.56 6.744 11.56 6.48V5.28H13.96V12.8928C13.96 13.8552 13.1752 14.64 12.2128 14.64H3.7072C2.7448 14.64 1.96 13.8552 1.96 12.8928V5.28Z"
          fill="currentColor"
        ></path>
      </svg>
    </Icon>
  );
};
